module.exports = __webpack_public_path__ + "img/load.b01956ed.gif";